module.exports = __webpack_public_path__ + "static/img/2.c3a4f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/2.png
// module id = 6So1
// module chunks = 0